const ROLES_PT = {
  admin: "Administrador",
  companion: "Companheiro",
  comptable: "Contabilista",
  gestionnaire: "Gestor",
  manager: "Gerente",
  membre: "Membro",
  operative: "Operador",
} as const;

export default ROLES_PT;
